import { Store } from '@ngrx/store';
// Constants
import { SPLIT_TYPE_OPTIONS } from 'ChartApp/ts/features/fundamental-chart/constants';
// NgRx
import { setFundChartSplitType } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/split-type/split-type.actions';
import { chartHasAnnotations } from 'ChartApp/ts/apps/fund-chart/state/reducers/chart-annotations/chart-annotations.selectors';
import { clearChartAnnotations } from 'ChartApp/ts/apps/fund-chart/state/reducers/chart-annotations/chart-annotations.actions';
import { getSplitType } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/split-type/split-type.selectors';
// Components
import { ConfirmModalComponent } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/components/modals/confirm-modal/confirm-modal.component";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/components/inputs/radio-button-group/radio-button-group.component";
/**
 *
 * Fund Chart Panel Layout Component
 * Input Properties:
 *   annotationsDisabled: Boolean representing whether chart annotations are enabled in the parent app. Annotations
 *                        should be enabled if the Fund Chart App and disabled in the Fund Chart Creator App.
 *
 */
export class FundChartPanelLayoutComponent {
    constructor(store) {
        this.store = store;
        this.panelLayoutOptions = SPLIT_TYPE_OPTIONS;
        this.splitTypeObj = { value: '' };
        this.newSplitType = '';
        this.chartHasAnnotations = false;
        this.mapStateToComponent = (state) => {
            this.chartHasAnnotations = chartHasAnnotations(state);
            this.splitType = getSplitType(state);
            this.splitTypeObj = { value: this.splitType };
        };
    }
    ngOnInit() {
        this.storeSubscription = this.store.select('reducers').subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    setSplitTypeHandler(splitType) {
        this.newSplitType = splitType;
        if (this.chartHasAnnotations) {
            this.confirmModalComponent.openModal();
        }
        else {
            this.store.dispatch(setFundChartSplitType({ splitType: this.newSplitType }));
        }
    }
    confirmSetSplitType(confirmed) {
        if (!confirmed) {
            this.splitTypeObj = { value: this.splitType };
            return;
        }
        this.store.dispatch(setFundChartSplitType({ splitType: this.newSplitType }));
        this.store.dispatch(clearChartAnnotations());
    }
}
FundChartPanelLayoutComponent.ɵfac = function FundChartPanelLayoutComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartPanelLayoutComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
FundChartPanelLayoutComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FundChartPanelLayoutComponent, selectors: [["ycn-fund-chart-panel-layout"]], viewQuery: function FundChartPanelLayoutComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(ConfirmModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.confirmModalComponent = _t.first);
    } }, standalone: false, decls: 6, vars: 5, consts: [[1, "panel-sidebar-section-header", "user-select-none"], [1, "panel-sidebar-section-title"], [1, "panel-sidebar-section-body", "user-select-none"], ["groupName", "panelLayout", 1, "custom-controls-stacked", 3, "selectHandler", "options", "selectedObject"], [3, "confirmHandler", "confirmHeader", "confirmButtonText", "confirmText"]], template: function FundChartPanelLayoutComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtext(2, "Panel Layout");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(3, "div", 2)(4, "ycn-radio-button-group", 3);
        i0.ɵɵlistener("selectHandler", function FundChartPanelLayoutComponent_Template_ycn_radio_button_group_selectHandler_4_listener($event) { return ctx.setSplitTypeHandler($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "ycn-confirm-modal", 4);
        i0.ɵɵlistener("confirmHandler", function FundChartPanelLayoutComponent_Template_ycn_confirm_modal_confirmHandler_5_listener($event) { return ctx.confirmSetSplitType($event); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("options", ctx.panelLayoutOptions)("selectedObject", ctx.splitTypeObj);
        i0.ɵɵadvance();
        i0.ɵɵproperty("confirmHeader", "Change Panel Layout")("confirmButtonText", "Continue")("confirmText", "Changing the panel layout will clear all existing chart annotations. Would you like to continue?");
    } }, dependencies: [i2.ConfirmModalComponent, i3.RadioButtonGroupComponent], encapsulation: 2 });
